<div class="pwa-install-container">
    <div class="message-title" translate>texts.IOS_PWA_Install_Title</div>
    <div class="message-text" translate>
        texts.IOS_PWA_Install_Description1
        &nbsp;<i class="fa-light fa-arrow-up-from-bracket"></i>&nbsp;
        texts.IOS_PWA_Install_Description2
    </div>
    <div class="button-container">
        <button class="close-button" (click)="maybeLater()" translate> texts.IOS_PWA_Install_Close </button>
    </div>
    <div class="blue-corner-element"></div>
</div>